import { useQuery } from '@apollo/client';

import { GetReviewableProductsQuery } from '@notino/shared/definitions/types';

import { useUser } from '@queries/useUser';

import getReviewableProductsQuery from './getReviewableProducts.graphql';

const MAX_REVIEWABLE_PRODUCTS = 4;

type ReviewableProduct =
  GetReviewableProductsQuery['reviewableProducts']['products'][number];

export type ReviewableProductWithUrl = Omit<ReviewableProduct, 'product'> & {
  product: NonNullable<ReviewableProduct['product']> & { url: string };
};

export const useReviewableProducts = () => {
  const { isLoggedIn } = useUser();

  const { data, loading } = useQuery<GetReviewableProductsQuery>(
    getReviewableProductsQuery,
    {
      variables: { pageSize: MAX_REVIEWABLE_PRODUCTS },
      skip: !isLoggedIn,
      fetchPolicy: 'cache-and-network',
    }
  );

  return {
    loading,
    products: (data?.reviewableProducts.products ?? []).filter(
      (item): item is ReviewableProductWithUrl => Boolean(item.product?.url)
    ),
  };
};
